"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLE_HEADER_CLASS = exports.TABLE_CELL_CLASS = exports.DATA_TABLE_CLASS_NAMES = void 0;
exports.embeddedTableClassNames = embeddedTableClassNames;
/**
 * ATOC-1 C1 — Erik: "Please apply the table formatting that was applied to the building areas to all
 * the other tables."
 *
 * The building-areas table is the reference: a denser row (py-1 rather than py-4, so roughly twice as
 * many rows fit on a screen), headers that never wrap mid-word, and the `justify-start` fix.
 *
 * That last one is not cosmetic. HeroUI's table wrapper is `flex flex-col justify-between`, so the
 * min-height below pins topContent to the top and the rows to the BOTTOM, leaving a tall empty band
 * in the middle whenever the result set is short — exactly what a search narrowing to one row
 * produces. The min-height itself is kept: it reserves space so the page does not jump each time the
 * loading spinner swaps in.
 */
var TABLE_HEADER_CLASS = "bg-gray-50 text-gray-600 font-semibold whitespace-nowrap py-2 px-2";
exports.TABLE_HEADER_CLASS = TABLE_HEADER_CLASS;
var TABLE_CELL_CLASS = "py-1 px-2";
exports.TABLE_CELL_CLASS = TABLE_CELL_CLASS;
/** For a table that IS the page — the full-height list screens. */
var DATA_TABLE_CLASS_NAMES = {
    wrapper: "min-h-[300px] justify-start md:min-h-[400px]",
    th: TABLE_HEADER_CLASS,
    td: TABLE_CELL_CLASS,
};
exports.DATA_TABLE_CLASS_NAMES = DATA_TABLE_CLASS_NAMES;
/**
 * Same row density and header treatment, but the caller keeps its own wrapper height.
 *
 * Tables embedded inside a page section — an area's occupancy history, a service's charges, an import
 * preview — are sized to their content. Giving them the full-page 300px floor would open a band of
 * empty space under three rows, which is the very thing `justify-start` exists to prevent. So the
 * formatting Erik asked for travels; the height does not.
 *
 *   classNames={embeddedTableClassNames("min-h-[100px]")}
 */
function embeddedTableClassNames(wrapperClass) {
    if (wrapperClass === void 0) { wrapperClass = ""; }
    return {
        wrapper: "justify-start ".concat(wrapperClass).trim(),
        th: TABLE_HEADER_CLASS,
        td: TABLE_CELL_CLASS,
    };
}
